import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import {
  CLEAR_AVAILABILITY_LIST,
  GET_AVAILABILITY_LIST,
  GET_AVAILABILITY_LIST_ERROR,
  GET_AVAILABILITY_LIST_RESET_SUCCESS,
  GET_AVAILABILITY_LIST_SUCCESS,
  SET_AVAILABILITY_PAGE_ERROR,
  SET_AVAILABILITY_PAGE_LOADING,
} from './AvailabilityConstants'

const initialState = {
  loading: false,
  error: '',
  availabilitiesList: {},
  lastListIncrease: '',
  visitTypesSortOptionsList: [],
}

export default function availabilityReducer(state = initialState, action = {}) {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case SET_AVAILABILITY_PAGE_ERROR: {
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        error: action.payload,
      }
    }
    case GET_AVAILABILITY_LIST: {
      return {
        ...state,
        loading: true,
      }
    }
    case CLEAR_AVAILABILITY_LIST: {
      return {
        ...state,
        availabilitiesList: [],
        lastListIncrease: '',
      }
    }
    case GET_AVAILABILITY_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        availabilitiesList: action.payload,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        lastListIncrease: action.payload?.length,
      }
    }
    case GET_AVAILABILITY_LIST_RESET_SUCCESS: {
      return {
        ...state,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        availabilitiesList: action.payload,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        lastListIncrease: action.payload?.length,
      }
    }
    case SET_AVAILABILITY_PAGE_LOADING: {
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        loading: action.payload,
      }
    }
    case GET_AVAILABILITY_LIST_ERROR:
      return {
        ...state,
        error:
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.payload.UserFriendlyErrorCode ?
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode)
          : getUserFriendlyErrorMessage(errorCodes.DEFAULT),
        loading: false,
      }
    default:
      return state
  }
}
